import http from './Http';

const login = async ({ dni, password }) => {
  return http.post(
    '/auth/login',
    {
      dni,
      password,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

const switchContext = async ({ institucion_id }) => {
  return http.post(
    '/auth/switch-context',
    {
      institucion_id,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

const validateCurrentPassword = async ({ current_password }) => {
  return http.post(
    '/auth/validate-password',
    {
      current_password,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

const changePassword = async ({ current_password, new_password, confirm_password }) => {
  return http.post(
    '/auth/change-password',
    {
      current_password,
      new_password,
      confirm_password,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
};

const getPerfil = async () => {
  return http.get('/auth/me'); 
};

const getRegiones = () => {
  return http.get("/ubicacion/regiones");
};

const getProvincias = (regionId) => {
  return http.get(`/ubicacion/provincias?region_id=${regionId}`);
};

const getDistritos = (provinciaId) => {
  return http.get(`/ubicacion/distritos?provincia_id=${provinciaId}`);
};

// Logout (cierra solo la sesión actual)
const logout = async () => {
  return http.post('/auth/me/logout');
};

const LoginService = {
  login,
  switchContext,
  validateCurrentPassword,
  changePassword,
  getPerfil,
  getRegiones,
  getProvincias,
  getDistritos,
  logout,
};

export default LoginService;
